export const getFaqs = (state) =>
  state.faq;



// WEBPACK FOOTER //
// ./src/store/selectors/faq.js